/**
 * スプレッドシートのデータの重複を省いてまとめる
 * @param {object} feedEntries スプレッドシートJSONフィードのエントリ配列
 * @returns ひとまとめにしたJSONオブジェクト
 * @example
    {
      "マルイチ": {
        "村井紙器": 1622590928000,
        "APS2020年度工事": 1623145597000
      },
      "豊田工業": {
        "三菱重工": 1623146472000,
        "ダイセル広畑工場": 1623145871000
      }
    }
 */
const reduceReports = feedEntries => feedEntries
  // 必要なデータだけ抜き出す
  .map(entry => ({
    client: entry['会社名'],
    timestamp: entry['タイムスタンプ'],
    project: entry['工事名'],
  }))
  // 同一プロジェクトをまとめて最新日付のみのエントリーにする
  .reduce((acc, current) => {
    // 最初のclientエントリ登録
    if (!acc[current.client]) acc[current.client] = {}
    // 日付文字列をパース
    const lastTimestamp = Date.parse(acc[current.client][current.project])
    const currentTimestamp = Date.parse(current.timestamp)
    // 最終日付をエントリ登録
    acc[current.client][current.project] = lastTimestamp > currentTimestamp ? lastTimestamp : currentTimestamp
    return acc
  }, {})

/**
 * スプレッドシートを読み込んでフォームのサジェスト用データを用意する
 * @example
    {
      "マルイチ": [
        ["APS2020年度工事", 1623145597000]
        ["村井紙器", 1622590928000],
      ],
      "豊田工業": [
        ["三菱重工", 1623146472000],
        ["ダイセル広畑工場", 1623145871000]
      ]
    }
 * @see https://developers.google.com/gdata/samples/spreadsheet_sample
 * @see https://gist.github.com/terrywbrady/a03b25fe42959b304b1e
 */
const extractProjectHistory = reportHistory =>
  // 整形する
  Object.entries(reduceReports(reportHistory))
    // サジェスト候補をソートするために、projectsを[project, timestamp]という配列にする
    .reduce((acc, [client, projects]) => {
      acc[client] = Object.entries(projects)
        // projectを日付で降順にソートする(最新のものが上に来るように)
        .sort(([, lastTimestamp], [, currentTimestamp]) => currentTimestamp - lastTimestamp)
      return acc
    }, {})

module.exports = extractProjectHistory
